module.exports = __webpack_public_path__ + "static/img/train_img.810ccd8d.png";